import { Navigate, Outlet } from 'react-router';
import { useAuth } from '@/contexts/AuthContext';
import BackofficeLayout from '@/components/layouts/BackofficeLayout';

export default function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-600" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <BackofficeLayout>
      <Outlet />
    </BackofficeLayout>
  );
}
